import { useEffect } from "react";
import { setTitle } from "@/hooks/useHeader.ts";

const RawHtml = ({ html, title }: { html: string; title: string }) => {
  useEffect(() => {
    setTitle(title);
  }, [title]);
  return (
    <div className="p-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl overflow-hidden rounded-lg bg-white shadow-md">
        <div className="px-4 py-5 sm:p-6">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </div>
    </div>
  );
};

export default RawHtml;
